import React from "react"
import { Tilt } from "react-tilt"
import { motion } from "framer-motion"
import { fadeIn, textVariant } from "../utils/motion"
import { styles } from "../styles"
import { projects } from "../constants"
import { SectionWrapper } from "../hoc"
import { Link } from "react-router-dom"
import { useState } from "react"
import { useLocation } from "react-router-dom"
const ProjectCard = ({ index, name, location, image, onClick }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={fadeIn("left", "spring", index * 0.3, 0.55)}
    >
      <Tilt
        options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
        className=" p-5 rounded-2xl w-[320px] sm:w-[460px] md:w-full mt-4"
      >
        <div className="relative w-full h-[250px] md:h-[330px] md:w-[400px] ">
          {" "}
          <Link to="/projects">
            <img
              src={image}
              alt="project_image"
              className="w-full h-full object-cover rounded-2xl"
              onClick={onClick}
            />
          </Link>
        </div>

        <div className="mt-5">
          <h3
            className="quote-title  text-[24px]"
            style={{ fontFamily: "Montserrat" }}
          >
            {name}
          </h3>
          <p className="mt-2  text-[14px]">{location}</p>
        </div>
      </Tilt>
    </motion.div>
  )
}

const Works = () => {
const [showFullHeight, setShowFullHeight] = useState(false)

  const handleShowMore = () => {
    setShowFullHeight(true)
    setScrollPosition(window.scrollY)
  }

  const handleShowLess = () => {
    const originalScrollBehavior = document.documentElement.style.scrollBehavior
    document.documentElement.style.scrollBehavior = 'auto'
    setShowFullHeight(false)
    window.scrollTo({top: scrollPosition, behavior: "auto"})
  }
  const [scrollPosition, setScrollPosition] = useState(0)
  const [selectedProject, setSelectedProject] = useState(null)
  const handleProjectClick = (project) => {
    setSelectedProject(project)
    localStorage.setItem("selectedProject", JSON.stringify(project))
  }
  return (
    <div className="mt-20  ">
      <div className=" px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] w-full">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={textVariant(0.3)}
        >
          <p
            className={`${styles.sectionHeadText} mt-10 mb-10 quote-title`}
            style={{ fontFamily: "Montserrat" }}
          >
            Our work
          </p>
        </motion.div>

        <div className="w-full flex   text-left px-3">
          <motion.p
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("", "", 0.4, 1)}
            className="mt-3 text-white text-[17px]  tracking-wider leading-[35px] mb-10 "
          >
            Akruti Concept Studio is a leading architecture firm renowned for
            their exceptional expertise and innovative approach to design. With
            a team of highly skilled architects, engineers, and designers, we
            specialize in creating stunning architectural marvels that
            harmoniously blend functionality, aesthetics, and sustainability.
            <br />
            Driven by our passion for innovation and a deep understanding of
            architectural principles, We have garnered numerous accolades and
            recognition for our outstanding contributions to the field. Our
            unwavering commitment to excellence, coupled with our ability to
            seamlessly blend form and function, has earned us a trusted
            reputation among clients and industry professionals alike.
            <br /> With a diverse and impressive portfolio of completed works,
            We continue to inspire and shape the architectural landscape with
            our visionary designs and unwavering commitment to delivering
            extraordinary architectural solutions.
          </motion.p>
        </div>
      </div>

      <div
        className={`mt-10 flex flex-wrap gap-7 justify-center overflow-hidden px-8 pb-4 ${
          showFullHeight ? "full-height" : "limited-height"
        }`}
      >
        {projects.map((project, index) => (
          <ProjectCard
            key={`project-${index}`}
            index={index}
            {...project}
            onClick={() => handleProjectClick(project)}
          />
        ))}
      </div>
      {!showFullHeight && (
        <div className=" flex relative mt-4 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px]">
          <button
            onClick={handleShowMore}
            className="bg-primary rounded-md py-3 px-3 cursor-pointer"
          >
            Show More
          </button>
        </div>
      )}
      {showFullHeight && (
        <div className="flex relative mt-4 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px]">
          <button
            onClick={handleShowLess}
            className="bg-primary rounded-md py-2 px-2 cursor-pointer "
          >
            Show Less
          </button>
        </div>
      )}
    </div>
  )
}

export default SectionWrapper(Works, "works")
